module.exports = __webpack_public_path__ + "img/Laughs.5cc0a252.png";